import React from 'react';
import Language from "@Components/Language";
import footerLogo from "@Assets/images/footer-logo.svg";

export default function Footer(props: { branding: string}) {
  const {branding} = props;
  const isAlinta = branding === "ALINTA";

  return (
    <>
    {!isAlinta ? (
      <>
        <div>
          {Language.get('The JMS platform is brought to you by')} <img src={footerLogo} alt="footer-logo"/>
        </div>
        <span>&copy;{new Date().getFullYear()}. {Language.get('All rights reserved  |  Privacy Policy  |  EULA')}</span>
      </>
    ) : (
      <div className="flex relative text-center w-full align-items-center justify-content-center flex-column md:flex-row">
        {import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO && (
          <img src={import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO
            &&  new URL(import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO, import.meta.url).href} alt="No Results" className="max-w-15rem mr-4 mobile-invert" />
        )}
        <>
          <span>&copy;{new Date().getFullYear()}. {Language.get('Journey Management System. All rights reserved.')}</span>
          <span>&nbsp;{Language.get('An')}&nbsp;<img src={footerLogo} alt="footer-logo"/>&nbsp;{Language.get('Product. EULA')}</span>
        </>
      </div>
    )}
    </>
  )
};
